import dayjs, { type ConfigType, type Dayjs } from "dayjs"
import utc from "dayjs/plugin/utc"

dayjs.extend(utc)

export type DateInput = ConfigType

export function utcNow() {
  return dayjs.utc()
}

export function utcUnixMs() {
  return utcNow().valueOf()
}

export function utcDayjs(value?: DateInput) {
  const parsed = value === undefined || value === null ? utcNow() : dayjs.utc(value)
  return parsed.isValid() ? parsed : null
}

export function utcDate(value?: DateInput) {
  return utcDayjs(value)?.toDate() ?? null
}

export function utcIsoString(value?: DateInput) {
  return utcDayjs(value)?.toISOString() ?? null
}

export function utcDateOnly(value?: DateInput) {
  return utcDayjs(value)?.format("YYYY-MM-DD") ?? null
}

export function utcPathParts(value?: DateInput | Dayjs) {
  const parsed = utcDayjs(value) ?? utcNow()
  return {
    year: parsed.format("YYYY"),
    month: parsed.format("MM"),
    day: parsed.format("DD"),
  }
}

export function utcObjectKeyTimestamp(value?: DateInput | Dayjs) {
  return (utcIsoString(value) ?? utcNow().toISOString()).replace(/[:.]/g, "-")
}

export function unixMsDate(value: number) {
  return dayjs.utc(value).toDate()
}
